module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rGmhik/tc-custom/9781781265307.jpg?1729082731004",
      "alt": "This image is the cover for the book A-Z of Sewing, A–Z of Needlecraft"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A-Z of Sewing, A–Z of Needlecraft\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A comprehensive guide to everything you need to know to create beautiful garments whether you hand sew or use a machine.")]), _c('br'), _c('br'), _vm._v("Aimed at anyone who has ever wanted to create their own garment from scratch or just fix a hem, "), _c('i', [_vm._v("A-Z of Sewing ")]), _vm._v("covers machine and hand sewing techniques, with over 180 sewing techniques explained. All techniques are meticulously demonstrated with step-by-step photographs to achieve a professional outcome. Readers are encouraged to develop their own creativity with plenty of hints and tips used by professional sewers. Includes sewing machine basics, equipment and supplies, working with patterns and fabrics and troubleshooting tips.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Country Bumpkin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Compiled by the expert team at Inspiraations magazine, renowned Australian publishers of embroidery books and magazines.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Country Bumpkin Publications\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0